import Assessment from 'modules/Assessments/Container/index'
import DirectAssessment from 'modules/Assessments/Components/DirectAssessment'
import PlacementPrep from '../../modules/Assessments/PlacementPrep'
import AIInterview from 'modules/Assessments/Partials/AIInterview'

export const anonymous = [
  // {
  //   routePath: '/onboarding/activate/:studentId',
  //   Component: ActivateStudent,
  // },
  // {
  //   routePath: '/not-interested/:studentId',
  //   Component: NotIntrested,
  // },
  // {
  //   routePath: '/not-interested/final/:studentId',
  //   Component: FinalPageNI,
  // },
  // {
  //   routePath: '*',
  //   Component: PageNotFound,
  // },
]

export const authenticated = [
  // {
  //   routePath: '/dashboard',
  //   Component: Dashboard,
  // },
  {
    routePath: '/assessment',
    Component: Assessment,
  },
  {
    routePath: '/assessment/direct/:assessment_assigned_id/:assessment_set_id',
    Component: DirectAssessment,
  },
  {
    routePath: '/ai-interview/:assignedId',
    Component: AIInterview,
  },
  {
    routePath: '/practice',
    Component: PlacementPrep,
  },
  // {
  //   routePath: '/assessment/behavioral',
  //   Component: Instructions,
  // },
  // {
  //   routePath: '/assessment/communication',
  //   Component: CommunicationInstructions,
  // },
  // {
  //   routePath: '/roles',
  //   Component: Roles,
  // },
  // {
  //   routePath: 'appliedroles/viewrole/:CorpID/:JobID',
  //   Component: ViewRole,
  // },
  // {
  //   routePath: 'roles/viewrole/:CorpID/:JobID',
  //   Component: ViewSingleRole,
  // },
  // {
  //   routePath: 'roles/viewrole/:CorpID/:JobID/questionnaire',
  //   Component: Questionnaire,
  // },
  // {
  //   routePath: 'roles/viewrole/:CorpID/:JobID/questionnaire/feedback',
  //   Component: Feedback,
  // },
  // {
  //   routePath: 'roles/questionnaire/:CorpID/:JobID/job/result',
  //   Component: ResultScreen,
  // },
  // {
  //   routePath: '/roles/questionnaire/:CorpID/:JobID/job/re-applied',
  //   Component: FailScreen,
  // },
  // {
  //   routePath: '/resume',
  //   Component: Resume,
  // },
  // {
  //   routePath: '/applied_roles/:Status',
  //   Component: Applied_Roles,
  // },
  // {
  //   routePath: '/applied_roles',
  //   Component: Applied_Roles,
  // },
  // {
  //   routePath: '/drives',
  //   Component: Drives,
  // },
  // {
  //   routePath: '/manageprofile',
  //   Component: ManageProfile,
  // },
  // {
  //   routePath: '/driveDetails/:RoleID/:DriveID',
  //   Component: DriveDetails,
  // },
  // {
  //   routePath: '/offerReceived',
  //   Component: OfferLetter,
  // },
  // {
  //   routePath: '/offerReceived/:Status',
  //   Component: OfferLetter,
  // },
  // {
  //   routePath: '/offerReceived/ExCand/:offerID',
  //   Component: OfferAccept,
  // },
  // {
  //   routePath: '/offerReceived/uploadDocument/:offerID',
  //   Component: OfferUploadDocument,
  // },
  // {
  //   routePath: '/onboarding/final/:studentId',
  //   Component: FinalPage,
  // },
  // {
  //   routePath: '/onboarding/register/:studentId',
  //   Component: Register,
  // },
  // {
  //   routePath: '/onboarding/notification/:studentId',
  //   Component: Notification,
  // },
  // {
  //   routePath: '/events',
  //   Component: Events,
  // },
  {
    routePath: '/',
    Component: Assessment,
  },
  {
    routePath: '*',
    Component: Assessment,
  },
]
